// extracted by css-extract-rspack-plugin
export default {"root":"root-kbJrEN","hidden":"hidden-ecafnc","background":"background-fLTIV_","preventScroll":"preventScroll-Ba9NxY"};